import * as actionTypes from "./actionTypes";

const initialState = {
  homeTableDetails: {
    loading: false,
    data: {}
  }
};

const fetchHomeTableStart = (state) => ({
  ...state,
  homeTableDetails: {
    loading: true
  }
});

const fetchHomeTableSuccess = (state, action) => ({
  ...state,
  homeTableDetails: {
    loading: false,
    data: {
      ...action.data
    }
  }
});

const fetchHomeTableFail = (state) => ({
  ...state,
  homeTableDetails: {
    loading: false
  }
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_HOME_TABLE_START:
      return fetchHomeTableStart(state, action);

    case actionTypes.FETCH_HOME_TABLE_SUCCESS:
      return fetchHomeTableSuccess(state, action);

    case actionTypes.FETCH_HOME_TABLE_FAIL:
      return fetchHomeTableFail(state, action);

    default:
      return state;
  }
};

export default reducer;
